<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page === 'query'"
    class="page"
  >
    <Header />
    <div class="mt3 mb5 fs5 fw4 fc--primary">
      預約查詢
    </div>
    <div
      class="page__content--m-50 page__content--l-40 page__content--xl-30 mb6
      "
    >
      <div class="page__form">
        <input
          type="text"
          v-model="memberInfo.twid"
          placeholder="身份證號碼"
          class="mb4"
        >
        <input
          type="text"
          v-model="memberInfo.birthdate"
          placeholder="西元生日(EX:19981018)"
          class="mb4"
        >
      </div>
    </div>
    <div class="row--central mb4">
      <div
        @click="$router.push('/')"
        class="label label--secondary mh3"
      >
        取消
      </div>
      <div
        @click="query"
        class="label label--primary mh3"
      >
        查詢
      </div>
    </div>
  </div>

  <div
    v-else-if="page === 'appointmentList'"
    class="page"
  >
    <Header />
    <div
      v-if="appointments.length === 0"
      class="page__text mt3 mb5"
    >
      無預約資料
    </div>
    <div
      v-else
      class="page__content--m-60 page__content--l-50 page__content--xl-40 mb2"
    >
      <div
        v-if="appointments.length > 0"
        class="page__text mt3 mb5"
      >
        <p>若欲更改預約</p>
        <p>請先取消預約後另約其他天</p>
      </div>
      <div
        v-for="(appointment, index) in appointments"
        :key="index"
        class="row bc--secondary border-radius--hot-dog pv4 mb6"
      >
        <div class="ml4 column--central">
          <div class="mv1 fs3 fc--primary">
            {{ spiderman.moment(appointment.date).format('MM/DD') }}
          </div>
          <div class="mv1 fs1">
            ({{ spiderman.moment(appointment.date)
              .locale('zh_cn').format('dd') }})
          </div>
        </div>
        <div class="column--central">
          <div class="mv1 fs3 fs--m-4 fw4">
            {{ appointment.doctor }}
          </div>
          <div class="mv1 fs1 fs--m-2 fw4">
            醫師
          </div>
        </div>
        <div class="column--central">
          <div class="mv1 row--central">
            <div class="fs2 fs--m-2 fs--l-3">
              建議報到時間
            </div>
          </div>
          <div class="mv1 row--central">
            <div class="fs2 fs--m-2 fs--l-3">
              (非實際看診時間)
            </div>
          </div>
          <div class="fc--primary mv1 fs1 fs--m-2 fs--l-3">
            {{ appointment.suggestedTime }}
          </div>
          <div class="mv1 fs1 fs--m-2 fs--l-3">
            {{ appointment.endCheckInTime }}看診結束
          </div>
        </div>
        <div class="column--central">
          <div class="mv1 fs4 fs--m-6 fc--primary">
            {{ appointment.waitingNumber }}
          </div>
          <div class="mv1 fs1">
            預約號碼
          </div>
        </div>
        <div class="mr4 column--central">
          <div class="row--central">
            <div
              @click="showCancelConfirmation(index)"
              class="label label--secondary ph2"
            >
              取消
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row--central mb4">
      <div
        @click="page='query'"
        class="label label--primary mh3"
      >
        重新查詢
      </div>
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @confirm="cancelAppointment"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import spiderman from '@/spiderman/index';
import api from '@/api/index';
import composable from '@/composable/index';

export default {
  setup() {
    const page = ref('initialization');
    const memberInfo = ref({
      twid: null,
      birthdate: null,
    });
    const appointments = ref([]);
    let cancelIndex = null;

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');
        if (!composable.member.jwt) {
          await composable.member.initialize();
        }
        page.value = 'query';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    async function query() {
      try {
        spiderman.form.verify(memberInfo.value);
        memberInfo.value.birthdate = spiderman.moment(memberInfo.value.birthdate).format('YYYY-MM-DD');

        composable.loading.show('預約記錄查詢中，請稍候。');

        appointments.value = await api.appointments.query(
          composable.member,
          memberInfo.value,
        );

        page.value = 'appointmentList';
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function showCancelConfirmation(index) {
      composable.modal.confirm(
        `確定取消 ${
          appointments.value[index].doctor
        }醫師 ${spiderman.moment(
          appointments.value[index].date,
        ).format('MM/DD')} ${appointments.value[index].timeSlotName}嗎？`,
      );
      cancelIndex = index;
    }

    async function cancelAppointment() {
      try {
        composable.modal.close();
        composable.loading.show('預約刪除中，請稍候。');
        await api.appointments.cancel(
          composable.member,
          appointments.value[cancelIndex],
        );
        appointments.value.splice(cancelIndex, 1);

        composable.modal.popup('預約刪除成功');
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    return {
      spiderman,
      composable,
      page,
      memberInfo,
      query,
      appointments,
      cancelAppointment,
      showCancelConfirmation,
    };
  },
};
</script>
